import { frontEndHandleResponse } from 'helper/frontEndHandleResponse';
import {baseUrl} from 'helper/ApiCall';

export const musicDirectorService = {
    login,
    logout,
    getAdudicators,
    getAdudicatorsRecordings,
    forgetUsername
}

function login(username, login_type = 'web'){
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username,login_type })
    };

    return fetch(baseUrl+'loginMusicDirector', requestOptions)
        .then(frontEndHandleResponse)
        .then(response => {
            // login successful if there's a jwt token in the response
            if (response.musicDirector) {
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                localStorage.setItem('music-director', JSON.stringify(response.musicDirector));
            }
            return response;
        });
}


function forgetUsername(email, request_type = 'web'){
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email,request_type })
    };

    return fetch(baseUrl+'forgetMusicDirector', requestOptions)
        .then(frontEndHandleResponse)
        .then(response => {
            // login successful if there's a jwt token in the response
            if (response.musicDirector) {
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                // localStorage.setItem('music-director', JSON.stringify(response.musicDirector));
            }
            return response;
        });
}

function logout() {
    // remove user from local storage to log user out
    localStorage.removeItem('music-director');
}


function getAdudicators(musicDirectorData){

    var formData = new FormData();
    formData.append('musicDirector_id', musicDirectorData.musicDirector_id);
    formData.append('username', musicDirectorData.username);
    formData.append('request_type', musicDirectorData.request_type);
    
    const requestOptions = {
        method: 'POST',
        body: formData
    };

    return fetch(baseUrl+'getAdjudicators', requestOptions)
        .then(frontEndHandleResponse)
        .then(company => {
            return company;
        });

}


function getAdudicatorsRecordings(adjudicatorObject, page){

    var formData = new FormData();
    formData.append('musicDirector_id', adjudicatorObject.musicDirector_id);
    formData.append('adjudicator_id', adjudicatorObject.adjudicator_id);
    formData.append('request_type', adjudicatorObject.request_type);
    
    const requestOptions = {
        method: 'POST',
        body: formData
    };

    return fetch(baseUrl+'getAdjudicatorCommentsWeb?page='+page, requestOptions)
        .then(frontEndHandleResponse)
        .then(company => {
            return company;
        });
}


// WEBPACK FOOTER //
// ./src/services/musicDirector.js